import styled from 'styled-components';
import { WebLink } from 'ui/theme';
import { CampaignFormField, ReadOnlyField } from '../../FormFields';

import { useTemplateContext } from '../../../context';
import { PushPrimaryContent } from '../../../types';

import { CommaSeparatedList, CommaSeparatedListItem, LightText } from '../Sections.styled';
import { RawJsonViewer } from './RawJsonViewer';

const OpenActionWrapper = styled.div`
  display: flex;
  flex-direction: column;
`;

const defaultActionMapper: Record<string, string> = {
  openApp: 'Open app',
  openUrl: 'Open URL',
};

export const PushBehavior = () => {
  const { templateAndContent } = useTemplateContext();
  const { primaryContent } = templateAndContent;
  const { defaultAction, actionButtons, sound, payload } = primaryContent as PushPrimaryContent;

  return (
    <>
      <CampaignFormField labelText="Open action">
        <ReadOnlyField name="openAction">
          {defaultAction ? (
            <OpenActionWrapper>
              <span>{defaultActionMapper?.[defaultAction?.type] || 'Custom action'}</span>
              {defaultAction?.data && (
                <WebLink href={defaultAction?.data}>{defaultAction?.data}</WebLink>
              )}
            </OpenActionWrapper>
          ) : (
            <LightText>Not set</LightText>
          )}
        </ReadOnlyField>
      </CampaignFormField>
      <CampaignFormField labelText="Action buttons">
        <ReadOnlyField name="actionButtons">
          {actionButtons?.length > 0 ? (
            <CommaSeparatedList>
              {actionButtons?.map((actionButton, index) => (
                <CommaSeparatedListItem key={index}>
                  {actionButton?.title || ''}
                </CommaSeparatedListItem>
              ))}
            </CommaSeparatedList>
          ) : (
            <LightText>Not set</LightText>
          )}
        </ReadOnlyField>
      </CampaignFormField>
      <CampaignFormField labelText="Custom sound">
        <ReadOnlyField name="customSound">{sound || <LightText>Not set</LightText>}</ReadOnlyField>
      </CampaignFormField>
      <RawJsonViewer payload={payload} />
    </>
  );
};
